import { render } from "./Academics.vue?vue&type=template&id=c67c1db6&ts=true"
import script from "./Academics.vue?vue&type=script&lang=ts"
export * from "./Academics.vue?vue&type=script&lang=ts"

import "./Academics.vue?vue&type=style&index=0&id=c67c1db6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__